$(document).ready(function() {
  const ONE_DAY = 24 * 60 * 60 * 1000;
  const dismissedAt = localStorage.getItem('announcement_dismissed_at');
  const isDismissed = dismissedAt && (Date.now() - parseInt(dismissedAt)) < ONE_DAY;

  if (!isDismissed) {
    $(".section-announcement-bar").addClass("is-visible");
    document.body.classList.remove("announcement-hide");
  }

  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");

    close_btns.each((index, close_btn) => {
      // edited by Yudi
      let parent_section = $(close_btn).closest(".section-announcement-bar");

      $(close_btn).on("click", () => {
				parent_section.removeClass("is-visible");
				document.body.classList.add("announcement-hide");
        localStorage.setItem('announcement_dismissed_at', Date.now().toString());
        requestAnimationFrame(() => {
          const header = document.querySelector('.shopify-section-header');
          if (header) {
            document.documentElement.style.setProperty(
              '--header-bottom-position',
              `${parseInt(header.getBoundingClientRect().bottom)}px`
            );
          }
        });
			});
    });
  }
});
